/**
 * Service layer para operações relacionadas ao usuário
 * Centraliza as chamadas de API e lógica de negócio
 */

import { API_Q_USER } from "../constants/api";

/**
 * Atualiza o perfil do usuário
 * @param {Function} fetchFn - Função de fetch do hook useFetch
 * @param {string} profileType - Tipo de perfil (professional, patient, personal)
 * @returns {Promise} Promise com o resultado da operação
 */
export const updateUserProfile = (fetchFn, profileType) => {
  return new Promise((resolve, reject) => {
    fetchFn({
      method: "PUT",
      url: API_Q_USER,
      data: { profile: profileType },
      onSuccess: (response) => resolve(response),
      onError: (error) => reject(error),
    });
  });
};

/**
 * Atualiza dados completos do usuário
 * @param {Function} fetchFn - Função de fetch do hook useFetch
 * @param {Object} userData - Dados do usuário para atualizar
 * @returns {Promise} Promise com o resultado da operação
 */
export const updateUser = (fetchFn, userData) => {
  return new Promise((resolve, reject) => {
    fetchFn({
      method: "PUT",
      url: API_Q_USER,
      data: userData,
      onSuccess: (response) => resolve(response),
      onError: (error) => reject(error),
    });
  });
};

/**
 * Busca dados do usuário atual
 * @param {Function} fetchFn - Função de fetch do hook useFetch
 * @returns {Promise} Promise com os dados do usuário
 */
export const fetchCurrentUser = (fetchFn) => {
  return new Promise((resolve, reject) => {
    fetchFn({
      method: "GET",
      url: API_Q_USER,
      onSuccess: (response) => resolve(response),
      onError: (error) => reject(error),
    });
  });
};

const userService = {
  updateUserProfile,
  updateUser,
  fetchCurrentUser,
};

export default userService;
